(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (window.customElements.get('cp-gift-remove')) return;

    class CpGiftRemove extends HTMLElement {
      connectedCallback() {
        if (this.__cpInit) return;
        this.__cpInit = true;
        var self = this;
        var btn = this.querySelector('button');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var key = self.getAttribute('data-line-key');
          if (!key || self.hasAttribute('aria-busy')) return;
          self.setAttribute('aria-busy', 'true');
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
          fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }).catch(function () {
            self.removeAttribute('aria-busy');
          });
        });
      }
    }

    window.customElements.define('cp-gift-remove', CpGiftRemove);
  })();

  } catch(e) { console.error(e); }
})();
})();
